/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { Field, FieldProps } from 'formik';
import { FormTextField } from 'components/TextField';

import useFieldCustomization from 'hooks/useFieldCustomization';
import useTranslate from 'hooks/useTranslate';
import withOptional from './withOptional';

const LoyaltyNumberField: React.FC = () => {
  const { isVisible, isRequired } = useFieldCustomization();
  const t = useTranslate();
  return (
    <React.Fragment>
      {isVisible('loyaltyNumber') && (
        <Field name="loyaltyNumber">
          {(fieldProps: FieldProps) => (
            <FormTextField
              id="creditAppLoyaltyNumber"
              fieldProps={fieldProps}
              required={isRequired('loyaltyNumber')}
              label={withOptional(
                t('formLabel.loyaltyNumber'),
                isRequired('loyaltyNumber'),
              )}
              inputProps={{
                inputMode: 'numeric',
                pattern: '[0-9]*',
              }}
            />
          )}
        </Field>
      )}
    </React.Fragment>
  );
};

export default LoyaltyNumberField;
